import type { Dayjs, QUnitType } from 'dayjs';
import dayjs from 'dayjs';

import i18n from '~/services/i18n';

export default class DateUtils {
  static humanizeDateDifference(endDate: Date, startDate: Date = new Date(), roundOff = false) {
    let unitOfTime: QUnitType | '' = '';
    let unitOfTimeText = '';

    if (dayjs(startDate).diff(endDate, 'year', roundOff) > 0) {
      unitOfTimeText = i18n('year');
      unitOfTime = 'year';
      if (dayjs(startDate).diff(endDate, 'year', roundOff) > 1) {
        unitOfTimeText = i18n('years');
      }
    } else if (dayjs(startDate).diff(endDate, 'month', roundOff) > 0) {
      unitOfTimeText = i18n('month');
      unitOfTime = 'month';
      if (dayjs(startDate).diff(endDate, 'month', roundOff) > 1) {
        unitOfTimeText = i18n('months');
      }
    } else if (dayjs(startDate).diff(endDate, 'day', roundOff) > 0) {
      unitOfTimeText = i18n('day');
      unitOfTime = 'day';
      if (dayjs(startDate).diff(endDate, 'day', roundOff) > 1) {
        unitOfTimeText = i18n('days');
      }
    } else if (dayjs(startDate).diff(endDate, 'hour', roundOff) > 0) {
      unitOfTimeText = i18n('hour');
      unitOfTime = 'hour';
      if (dayjs(startDate).diff(endDate, 'hour', roundOff) > 1) {
        unitOfTimeText = i18n('hours');
      }
    } else if (dayjs(startDate).diff(endDate, 'minute', roundOff) > 0) {
      unitOfTimeText = i18n('minute');
      unitOfTime = 'minute';
      if (dayjs(startDate).diff(endDate, 'minute', roundOff) > 1) {
        unitOfTimeText = i18n('minutes');
      }
    } else if (dayjs(startDate).diff(endDate, 'second', roundOff) > 0) {
      unitOfTimeText = i18n('second');
      unitOfTime = 'second';
      if (dayjs(startDate).diff(endDate, 'second', roundOff) > 1) {
        unitOfTimeText = i18n('seconds');
      }
    }

    return `${Math.round(dayjs(startDate).diff(endDate, unitOfTime as QUnitType, roundOff))} ${unitOfTimeText}`;
  }

  static getMonthName(idx: number): string {
    if (idx > 11) {
      return '-';
    }

    const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

    return months[idx];
  }

  static isDateInRange(dateToCheck: Date, startDate: Date, endDate: Date | undefined) {
  // Convert string dates to Date objects
    const checkDate = new Date(dateToCheck);
    const startDateObj = new Date(startDate);

    // If endDate is provided, convert it to Date object
    let endDateObj;
    if (endDate) {
      endDateObj = new Date(endDate);
    }

    // Check if the provided date is after or equal to startDate
    // If endDate is provided, also check if it's before or equal to endDate
    if (endDateObj) {
      return checkDate >= startDateObj && checkDate <= endDateObj;
    } else {
    // If endDate is not provided, only check against startDate
      return checkDate >= startDateObj;
    }
  }

  static formattedTime(time: Dayjs | null | undefined, format = 'MMM DD, YYYY, hh:mm A') {
    if (!time) {
      return '';
    }

    const timeWrapped = dayjs(time);
    const timeFormatted = timeWrapped.format(format);

    return `${timeFormatted}`;
  }
}
